var _style, _defs, _polygon, _defs2, _polygon2, _defs3, _polygon3, _defs4, _polygon4, _defs5, _polygon5, _defs6, _polygon6, _defs7, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolfit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 629.7 191.4",
    style: {
      enableBackground: "new 0 0 629.7 191.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\n\t.st2{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\n\t.st3{clip-path:url(#SVGID_11_);fill:url(#SVGID_12_);}\n\t.st4{clip-path:url(#SVGID_14_);fill:url(#SVGID_15_);}\n\t.st5{clip-path:url(#SVGID_17_);fill:url(#SVGID_18_);}\n\t.st6{clip-path:url(#SVGID_20_);fill:#FFCF04;}\n\t.st7{clip-path:url(#SVGID_20_);fill:#228B44;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M258.9,109.8h28.9c10.2,0,16.8,5.5,16.8,13.7c0,8.6-6.6,13.9-16.8,13.9h-28.9V109.8z M258.9,67.2h26.7 c9.5,0,15.6,4.9,15.6,12.7c0,7.8-6.1,12.7-15.6,12.7h-26.7V67.2z M236.7,48.9v106.9h52.7c22.5,0,37.4-12.4,37.4-31 c0-10.5-6.6-19.2-16.8-24.1c8.1-5,13.1-13.1,13.1-22.4c0-17.4-14.7-29.3-36.2-29.3H236.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 191.3966,
    x2: 1,
    y2: 191.3966,
    gradientTransform: "matrix(-127.44 61.56 61.56 127.44 -11211.8496 -24428.707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000675134,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "368.7,135.6 253.8,191.1 194.9,69.1 309.8,13.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M357.7,116.1c0-13.1,9.8-23.2,22-23.2c12.4,0,22,10.1,22,23.2c0,12.8-9.6,23.1-22,23.1 C367.3,139.1,357.7,128.9,357.7,116.1 M337.2,116.1c0,23.2,18.6,41.2,42.5,41.2c23.8,0,42.5-18,42.5-41.2 c0-23.2-18.6-41.4-42.5-41.4C355.9,74.7,337.2,92.9,337.2,116.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 191.3569,
    x2: 1,
    y2: 191.3569,
    gradientTransform: "matrix(-127.44 61.56 61.56 127.44 -11185.5303 -24374.2227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000675134,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.5,141.7 353.3,190.6 304.9,90.3 406.1,41.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_7_",
    points: "435,48.9 435,155.8 455.9,155.8 455.9,44.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 191.3424,
    x2: 1,
    y2: 191.3424,
    gradientTransform: "matrix(-127.44 61.56 61.56 127.44 -11178.4512 -24359.5664)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000675134,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "499.6,134.7 438.9,164 391.3,65.4 451.9,36.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M484.5,68.6v7.6h-17.7v17.6h17.7v62h20.9v-62h21.7V76.2h-21.7V69c0-7,4-10.4,11.9-10.4 c3.4,0,6,0.5,9.8,1.2V42.3c-3.4-0.9-8.1-1.4-12.4-1.4C495.2,40.9,484.5,50.7,484.5,68.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 191.3319,
    x2: 1,
    y2: 191.3319,
    gradientTransform: "matrix(-127.44 61.56 61.56 127.44 -11168.7227 -24339.4277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000675134,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "572.1,134.1 478.2,179.4 421.8,62.7 515.7,17.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M538.1,155.8H559V76.2h-20.9V155.8z M536.5,54.8c0,6.6,5.3,11.9,11.9,11.9c6.6,0,11.9-5.3,11.9-11.9 c0-6.6-5.3-11.9-11.9-11.9C541.9,42.9,536.5,48.3,536.5,54.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 191.345,
    x2: 1,
    y2: 191.345,
    gradientTransform: "matrix(-127.44 61.56 61.56 127.44 -11159.3896 -24320.1074)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000675134,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "604.6,134.4 541,165.1 492.3,64.3 555.9,33.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M586.2,55.9v20.3h-16.3v17.6h16.3v39.6c0,15.6,9.2,23.7,26.9,23.7c4.6,0,11.8-1.1,16.2-2.4v-17.1 c-4.1,1.4-7.2,1.8-11.1,1.8c-8.1,0-11-2.8-11-10.2V93.8h22.6V76.2h-22.6v-25L586.2,55.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 191.3253,
    x2: 1,
    y2: 191.3253,
    gradientTransform: "matrix(-127.44 61.56 61.56 127.44 -11146.6152 -24293.6621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000675134,
    style: {
      stopColor: "#68B32E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#238B44"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "671.2,137 581.2,180.5 528.4,71.2 618.4,27.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    width: 629.7,
    height: 191.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.8,2.5c1.8,22.5,12.3,42,25.1,60.6c9.7,14,19.5,27.8,21.1,45.5c1.7,19-5.6,33.8-22.1,44 c-16.5,10.1-37.4,10.1-53.9,0c-16.6-10.2-23.9-25-22.1-44c1.4-15.7,9.3-28.6,18.2-41.2C79,47.4,91.1,26.9,93,2.7l0-0.2 C93.5-0.8,98.3-0.8,98.8,2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.3,107.1c0-30.4,17.2-56.8,42.3-70c1.6-0.9,3.6-0.3,4.7,1.2l1,1.6c1.2,1.9,3.6,1.3,5-0.4l11.4-14.8 c1.6-2.1,0.4-5.1-2.2-5.4l-26-3.9c-1.8-0.2-3,1.8-2,3.3l1.7,2.7c1.2,1.8,0.6,4.3-1.4,5.3C18.9,41.2,0,69.3,0,101.5 c0,46.2,38.8,83.8,87.4,85.7c0.3,0,0.6-0.2,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6C45.6,184,12.3,149.4,12.3,107.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M182.1,99.6c0,30.4-17.2,56.8-42.3,70c-1.6,0.9-3.6,0.3-4.6-1.2l-1-1.6c-1.2-1.9-3.6-1.6-5,0.4L117.7,182 c-1.6,2.1-0.4,5.1,2.2,5.4l26,3.9c1.8,0.2,3-1.8,2-3.3l-1.7-2.7c-1.2-1.8-0.6-4.3,1.4-5.3c27.9-14.7,46.8-42.7,46.8-74.9 c0-46.2-38.8-83.8-87.4-85.7c-0.3,0-0.6,0.2-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6C148.8,22.7,182.1,57.2,182.1,99.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolfit);
export default __webpack_public_path__ + "static/media/bolfit.ea4c1f5b5f116c6abcf993431c10c785.svg";
export { ForwardRef as ReactComponent };